import React, { HTMLAttributes } from 'react';
import BatchSizeInspector from './components/batch-size-inspector';
import CommonSizeInspector from './components/common-size-inspector';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    width: number;
    height: number;
    disableHeight: boolean;
    disableWidth: boolean;
    lock: boolean;
    lockRatio: boolean;
    showBatchSizeInspector: boolean;
    uniformSize: { width: number | null; height: number | null } | null;
    onSize?: () => void;
}
const SizeInspector: React.FC<IProps> = ({
    id,
    width,
    height,
    disableHeight,
    disableWidth,
    lock,
    lockRatio,
    uniformSize,
    showBatchSizeInspector,
    onSize,
}) => {
    return (
        <React.Fragment>
            {showBatchSizeInspector ? (
                <BatchSizeInspector id={id} size={uniformSize} onSize={onSize} />
            ) : (
                <CommonSizeInspector
                    id={id}
                    width={width}
                    height={height}
                    disableHeight={disableHeight}
                    disableWidth={disableWidth}
                    lock={lock}
                    lockRatio={lockRatio}
                    onSize={onSize}
                />
            )}
        </React.Fragment>
    );
};
export default React.memo(SizeInspector);
